import { backendErrorsHelper } from "@gymflow/helpers";
import { isAxiosError } from "axios";
import { api } from "libs/api/src/lib/apiV2/api";
import { MANUALLY_HANDLED_ERROR_CODES } from "libs/helpers/src/constants/ManuallyHandledErrorCodes";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { apiOld } from "../../../../libs/api/src/lib/apiV2/apiOld";
import { ToastContext } from "./ToastProvider/context";

export const ErrorParserProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { t, i18n } = useTranslation();
  const { toast } = useContext(ToastContext);
  useEffect(() => {
    const errorCallback = (error: any) => {
      if (!isAxiosError(error)) return Promise.reject(error);
      if (
        error.config?.method !== "get" &&
        error.status !== 426 &&
        error.response?.data
      ) {
        const parsedError = backendErrorsHelper.parseError(error);
        if (!MANUALLY_HANDLED_ERROR_CODES.includes(parsedError.errorCode)) {
          toast({
            message: t("backendErrorsPortal.generic"),
            description:
              parsedError.errorCode &&
              i18n.exists(`backendErrorsPortal.${parsedError.errorCode}`)
                ? t(
                    `backendErrorsPortal.${parsedError.errorCode}`,
                    parsedError.interpolationMap,
                  )
                : parsedError.fallbackMessage,
            intent: "error",
          });
        }
      }
      return Promise.reject(error);
    };
    const interceptorIdOld = apiOld.interceptors.response.use(
      (response) => response,
      errorCallback,
    );
    const interceptorId = api.interceptors.response.use(
      (response) => response,
      errorCallback,
    );

    return () => {
      apiOld.interceptors.response.eject(interceptorIdOld);
      api.interceptors.response.eject(interceptorId);
    };
  }, [toast, t, i18n]);
  return children;
};
